import get from 'lodash/get';
import Link from 'next/link';
import { HiTag } from 'react-icons/hi';
import { IoMdCalendar } from 'react-icons/io';

import global from '../../../styles/layout.module.scss';
import { formatDate } from '../../utils/dayjs';
import SidebarCMS from '../SidebarCMS/SidebarCMS';

import styles from './LayoutDynamic.module.scss';
import Pagination from './Pagination';

export default function LayoutDynamic({ data, path, categories, categoryTitle, query, appLinks, contentName }) {
  return (
    <section className={global.section}>
      <div className={global.container}>
        <div className={global.row}>
          <div className={styles.column}>
            {data.data.map(d => (
              <div key={d.uuid} className={styles.card}>
                {Boolean(get(d, 'fields.cover_image')) && (
                  <Link href={`${path}/${d.slug}`}>
                    <a>
                      <img className={styles.img} src={d.fields.cover_image.path} alt="Card  cap" />
                    </a>
                  </Link>
                )}

                <div className={styles.body}>
                  <h2 className={styles.title}>
                    <Link href={`${path}/${d.slug}`}>
                      <a>{d.title}</a>
                    </Link>
                  </h2>
                  <div className={styles.meta}>
                    <div className={styles.tags}>
                      <div className={styles.tagsInfo}>
                        <span>
                          <IoMdCalendar className={styles.calendarIcon} alt="εικονίδιο ημερομηνίας" />
                        </span>
                        <p>{formatDate(d.ct, 'DD MMMM, YYYY')}</p>
                      </div>
                      {Boolean(get(d, 'fields.categories.length')) && (
                        <div className={styles.tagsInfo}>
                          <span>
                            <HiTag className={styles.calendarIcon} alt="εικονίδιο κατηγοριών άρθρου" />
                          </span>
                          {d.fields.categories.map((category, i) => (
                            <Link key={category.uuid} href="#">
                              <a>
                                {category.title} {d.fields.categories.length === i + 1 ? '' : ', '}
                              </a>
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <p className={styles.text}>{d.fields.summary}</p>
                  <Link href={`${path}/${d.slug}`}>
                    <a className={styles.more}>Μάθε περισσότερα &gt;</a>
                  </Link>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.aside}>
            <SidebarCMS
              categories={categories}
              appLinks={appLinks}
              contentName={contentName}
              categoryTitle={categoryTitle}
            />
          </div>
        </div>
      </div>
      <Pagination data={data.pagination} path={path} query={query} />
    </section>
  );
}
